<div
  class="bg-warning p-1 d-flex align-items-center justify-content-center border border-dark-gray border-left-0 border-end-0 border-top-0"
  *ngIf="!buildIsUpToDate && isReloadRequired"
>
  <div class="d-flex justify-content-center align-items-center gap-3">
    <p class="m-0 fw-bold">{{ 'pageUpdate.staticMessage' | translate }}</p>
    <base-button
      label="pageUpdate.reload"
      color="dark"
      [size]="buttonSizes.xs"
      (btnClick)="reloadPage()"
    ></base-button>
  </div>
</div>

<ng-template #refreshAppVersionTemplate>
  <div class="d-flex flex-column">
    <p class="fw-bold">{{ 'pageUpdate.descriptionPart1' | translate }}</p>
    <p>{{ 'pageUpdate.descriptionPart2' | translate }}</p>
  </div>
</ng-template>
